module.exports = __webpack_public_path__ + "Icon_Roles Management.a5b18df2f60e1fe08ed0.png";